import React from 'react';
import Link from '../Link';

if (process.browser) require('./Tabs.scss');

// TODO - click tracking on this
const StateTab = ({
  id,
  selected,
  label,
  onSelect,
}) => (
  <div
    className={`tab ${selected ? 'active-tab' : ''}`}
    id={`tab-${id}`}
    role="tab"
    tabIndex="0"
    aria-controls={`panel-${id}`}
    aria-selected={selected}
    onClick={!selected && onSelect}
    data-tab={`tab-${id}`}
  >
    { label }
  </div>
);

const getTrack = ({
  to, track, track: { value }, label
}) => ({
  ...track,
  action: 'SwitchTabs',
  value: { ...value, path: to },
  label
});
const RouteTab = ({
  id, to, rel, track, label
}) => (
  <Link
    id={id ? `tab-${id}` : undefined}
    to={to}
    rel={rel}
    exact
    className="tab"
    activeClassName="active-tab"
    track={getTrack({ to, track, label })}
    data-tab="tab"
  >
    { label }
  </Link>
);

const TabList = ({ children }) => (
  <div className="tabs">
    <div className="nav-tabs" role="tablist">
      { children }
    </div>
  </div>
);

export default function Tabs({
  tabs = [],
  onChange,
  selectedIndex,
  routed,
  track,
}) {
  if (!tabs.length) return null;

  const Tab = routed ? RouteTab : StateTab;

  return (
    <TabList>
      {
        tabs.map((tab, index) => (
          <Tab
            {...tab}
            selected={selectedIndex === index}
            onSelect={() => onChange && onChange(index)}
            key={tab.id}
            track={track}
          />
        ))
      }
    </TabList>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Tabs/Tabs.js